export default {
    stockLogs: [],
    totalDataRow:0 
}
  